module.exports = __webpack_public_path__ + "static/media/energy-efficient-standards.4ee382ca.svg";